var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toptag"},_vm._l((_vm.toptagList),function(item){return _c('div',{key:item.id,staticClass:"toptag-item",class:{ active: item.id === _vm.activeId},on:{"click":function($event){return _vm.goUrl(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }